var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.checkStepRegistration(6))?_c('k-analize'):_vm._e(),(_vm.checkStepRegistration(7))?_c('k-working'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }